import React from 'react';
import { Button } from '@/components/ui/button';
import { Phone, MessageCircle } from 'lucide-react';
import { isColorDark } from '../utils';

const MobileBottomBar = ({ shop, accentColor, onWhatsApp, onCall, theme }) => {
  const hasWhatsApp = !!shop.whatsappNumber;
  const hasPhone = !!shop.phone;
  const hasBoth = hasWhatsApp && hasPhone;

  if (!hasWhatsApp && !hasPhone) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 p-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] z-40 lg:hidden backdrop-blur-lg" style={{ backgroundColor: `${theme.cardBg}ee`, borderTop: `1px solid ${theme.borderColor}` }} data-testid="mobile-bottom-bar">
      <div className="max-w-2xl mx-auto flex gap-2">
        {hasWhatsApp && (
          <Button 
            className={`h-12 rounded-xl gap-2 text-sm font-semibold shadow-md text-white ${hasBoth ? 'flex-1 min-w-0' : 'flex-1'}`}
            style={{ backgroundColor: '#25D366' }}
            onClick={onWhatsApp}
            data-testid="mobile-whatsapp-btn"
          >
            <MessageCircle className="w-5 h-5 shrink-0" />
            <span className="truncate">WhatsApp</span>
          </Button>
        )}
        {hasPhone && (
          <Button 
            className={`h-12 rounded-xl gap-2 text-sm font-semibold ${hasBoth ? 'flex-1 min-w-0' : 'flex-1'}`}
            style={{ backgroundColor: accentColor, color: isColorDark(accentColor) ? '#fff' : '#000' }}
            onClick={onCall}
            data-testid="mobile-call-btn"
          >
            <Phone className="w-5 h-5 shrink-0" />
            <span className="truncate">Appeler</span>
          </Button>
        )}
      </div>
    </div>
  );
};

export default MobileBottomBar;
